import React from 'react';

export default function ProjectSection({ id, project, language }) {
  return (
    <div
      className={`px-10 py-12 ${
        id % 2 === 0 ? 'bg-white' : 'xl:flex-row-reverse'
      } flex flex-col xl:flex-row gap-10 xl:gap-20`}
    >
      <div className="basis-1/2">
        <h3
          className={`font-bold text-3xl ${id % 2 === 0 ? '' : 'text-white'}`}
        >
          {language === 'it' && project.titolo_it}
          {language === 'en' && project.titolo_en}
        </h3>
        <hr className="mt-4 border-b-4 border-blue-400" />
        {language === 'it' && (
          <p
            className={`mt-4 ${id % 2 === 0 ? '' : 'text-white'}`}
            dangerouslySetInnerHTML={{
              __html: project.descrizione_it,
            }}
          ></p>
        )}
        {language === 'en' && (
          <p
            className={`mt-4 ${id % 2 === 0 ? '' : 'text-white'}`}
            dangerouslySetInnerHTML={{
              __html: project.descrizione_en,
            }}
          ></p>
        )}
      </div>
      <div className="flex basis-1/2">
        <img
          src={project.immagine.url}
          alt={project.immagine.alt}
          className="w-full aspect-video"
        />
      </div>
    </div>
  );
}
